import { swiperSustentabilidad, swiperManantialesDestacados, swiperLeedCities, swiperLeedCitiesCaption, swiperCaracteristicasCertificacion, swiperNormas } from '../functions/swiperInit.js';
import { playerPlaceholder } from '../functions/player-placeholder.js';


document.addEventListener("DOMContentLoaded", () => {

    playerPlaceholder();
    swiperSustentabilidad();
    swiperNormas();
    swiperManantialesDestacados();
    swiperCaracteristicasCertificacion();
    swiperLeedCities;
    swiperLeedCitiesCaption;

    swiperLeedCities.controller.control = swiperLeedCitiesCaption;
    swiperLeedCitiesCaption.controller.control = swiperLeedCities;

});
